// Import Highcharts modules
import * as Highcharts from 'highcharts';
import '../../highcharts-options';

import { getKeyTime, clickOnLegendItem, highchartsPalette } from '../../../utils';

import chartsStyle from '../../../../public/config/charts-style.json';

import { Aeroval } from '../../../types/global';
import { ForecastData } from '../../../types/data';
declare var aeroval: Aeroval;


export function plotForecast(data: ForecastData, parameterDir: string, observation: string, layer: string, statisticDir: string, div: string, chartOptions: any = {}) {
	const series = [] as any;
	const subData = data[parameterDir][observation][layer];
	const keyTime = getKeyTime(aeroval.time, aeroval.season);
	const models = (!chartOptions.models || chartOptions.models === 'all') ? Object.keys(subData) as string[] : chartOptions.models;

	const unit = aeroval.statistics[statisticDir].unit;

	var i = 0;
	for (const model of models) {
		const modVar = Object.keys(subData[model])[0];

		// set model style
		const highchartsColor = highchartsPalette(i);
		const modelStyle = aeroval.modelStyle[model];
		const modelZIndex = modelStyle?.zIndex ?? 1;
		const colorModel = modelStyle?.color ? modelStyle.color : highchartsColor;
		const modelWeight = modelStyle?.weight ? modelStyle.weight : 1;
		const modelDashStyle = modelStyle?.dashStyle ? modelStyle.dashStyle : 'Solid';
		const markerSizeModel = modelWeight * chartsStyle['frcst-ts']['mod'].markerSize * Number(aeroval.settings.lineWidthFactor);
		const lineWidthModel = modelWeight * chartsStyle['frcst-ts']['mod'].lineWidth * Number(aeroval.settings.lineWidthFactor);

		//here we overwrite the visibility
		const visible = typeof aeroval.seriesVisibility[model] != 'undefined' ? aeroval.seriesVisibility[model] : true
		const statistics = subData[model][modVar][keyTime]?.[statisticDir] ? subData[model][modVar][keyTime][statisticDir] : null

		if (statistics && unit == '%') {
			for (let j = 0; j < statistics.length; j++) {
				if (statistics[j] != null) {
					statistics[j] = statistics[j] * 100;
				}
			}
		}

		series.push({
			data: statistics,
			color: colorModel,
			name: model,
			id: `mod-${model}`,
			visible: visible,
			lineWidth: lineWidthModel,
			dashStyle: modelDashStyle,
			marker: {
				radius: markerSizeModel,
			},
			weight: modelWeight,
			zIndex: modelZIndex
		});
		i++;
	}


	// set axis unit and title

	const axisUnit = unit != '1' ? `(${unit})` : ''
	const parameterName = aeroval.menu[parameterDir].name
	var titleText = aeroval.season == 'All' ? `${parameterName} - ${aeroval.region} - ${aeroval.time}` : `${parameterName} - ${aeroval.region} -${aeroval.time} (${aeroval.season})`
	const statisticName = aeroval.statistics[statisticDir].name

	var subtitleText = observation;
	// if the frequency of the stats in the time series is different from the main freq, display the used frequency
	if ('stats_tseries_base_freq' in aeroval.cfg.statistics_opts && aeroval.cfg.statistics_opts.stats_tseries_base_freq != null) {
		if (aeroval.cfg.statistics_opts.stats_tseries_base_freq != aeroval.cfg.time_cfg.main_freq) {
			subtitleText += ' (statistics computed from ' + aeroval.cfg.statistics_opts.stats_tseries_base_freq + ' values)';
		}
	}

	const legendEnabled = chartOptions.legend && chartOptions.legend.hasOwnProperty('enabled') ? chartOptions.legend.enabled : true
	if (chartOptions.title?.enabled == false) {
		titleText = ''
		subtitleText = ''
	}

	Highcharts.chart({
		chart: {
			renderTo: div,
			type: aeroval.settings.lineType,
			zooming: { type: 'x' },
			height: chartOptions && chartOptions.height ? chartOptions.height : 500,
			resetZoomButton: {
				position: {
					align: 'center',
				},
			},
		},
		title: {
			text: titleText,
		},
		subtitle: {
			text: subtitleText,
		},
		tooltip: {
			shared: true,
			valueDecimals: 3,
			headerFormat: 'Hour ({point.point.x}) <br>',
		},
		yAxis: {
			title: {
				text: `Median of ${statisticName} ${axisUnit}`,
			},
			//softMin: 0,
		},
		xAxis: {
			//type: 'datetime',
			title: {
				text: 'Hour',
			},
			tickInterval: 6,
			plotLines: [
				{
					width: 3,
					value: 24,
					color: 'rgba(153, 153, 153, .25)',
				},
				{
					width: 3,
					value: 48,
					color: 'rgba(153, 153, 153, .25)',
				},
				{
					width: 3,
					value: 72,
					color: 'rgba(153, 153, 153, .25)',
				},
			],
			events: {
				setExtremes: function (e) {
					setZoomState(e);
				},
			},
		},
		legend: {
			layout: 'horizontal',
			align: 'center',
			verticalAlign: 'bottom',
			floating: false,
			enabled: legendEnabled
		},
		plotOptions: {
			series: {
				events: {
					legendItemClick: function () {
						clickOnLegendItem(this);
					},
				},
				states: {
					inactive: {
						enabled: false,
					},
				},
			},
		},
		series,
	});
}

function setZoomState(e: Highcharts.AxisSetExtremesEventObject) {
	if (e.max && e.min) {
		aeroval.zoom = {
			state: true,
			min: e.min,
			max: e.max,
		};
	} else {
		aeroval.zoom = {
			state: false,
			min: null as any,
			max: null as any,
		};
	}
}
